import { SearchAttribute } from "../models/search.attribute";

export function filterSearch<T>(array: T[], searchAttributes: SearchAttribute[]) {
  const reduce = searchAttributes.reduce((filteredCartons, searchAttribute) => {
    const { attribute, values } = searchAttribute;

    if (attribute.includes(".")) {
      const [objectName, objectProperty] = attribute.split(".");

      return filteredCartons.filter((object: any) => {
        return values.some((value) => {
          const nestedObject = object[objectName];

          if (nestedObject && nestedObject instanceof Array) {
            return nestedObject.find((object) =>
              object[objectProperty]?.toLowerCase()?.includes(value.toLowerCase())
            );
          }

          return String(nestedObject?.[objectProperty])
            ?.toLowerCase()
            ?.includes(value.toLowerCase());
        });
      });
    }

    return filteredCartons.filter((object: any) => {
      return values.some((value) => {
        return String(object[attribute])?.toLowerCase()?.includes(value.toLowerCase());
      });
    });
  }, array);

  return reduce;
}
